// extracted by mini-css-extract-plugin
export default {"body":"AffiliatePamView_body__yzHDF"};